(() => {
  const ROOT = document.documentElement;
  const tr = text => (typeof __ === "function" ? __(text) : text);
  window.mgosModeState = window.mgosModeState || {
    status: "loading", mode: "UNKNOWN", role: null, demoAvailable: false,
  };
  window.mgosDataMode = window.mgosModeState.mode;
  window.mgosDemoRole = window.mgosModeState.role;
  window.mgosModeUnavailable = window.mgosModeState.status !== "ready";
  const STYLE_ID = "mgos-active-theme-css";
  const PREFIX = "--mg-";
  const TOKEN_MAP = {
    brand: "brand",
    brand_soft: "brand-soft",
    structure: "structure",
    structure_hover: "structure-hover",

    secondary: "secondary",
    secondary_dark: "secondary-dark",
    secondary_soft: "secondary-soft",

    accent: "accent",
    highlight: "highlight",

    background: "bg",
    surface: "surface",
    surface_alt: "surface-alt",

    text: "text",
    text_inverse: "text-inverse",
    muted: "muted",

    border: "border",
    border_soft: "border-soft",

    focus: "focus",
    selection: "selection",

    success: "success",
    success_soft: "success-soft",
    warning: "warning",
    warning_soft: "warning-soft",
    danger: "danger",
    danger_soft: "danger-soft",
    info: "info",
    info_soft: "info-soft",

    radius: "radius",
    radius_small: "radius-sm",
    shadow: "shadow",
    font: "font"
  };

  const slug = value =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");


  function styleNode() {
    let node =
      document.getElementById(
        STYLE_ID
      );

    if (!node) {
      node =
        document.createElement(
          "style"
        );

      node.id = STYLE_ID;

      document.head.appendChild(
        node
      );
    }

    return node;
  }


  function applyTokens(theme) {
    const tokens =
      theme.tokens || {};

    Object.entries(
      TOKEN_MAP
    ).forEach(
      ([token, cssName]) => {

        if (
          tokens[token] !== undefined
          && tokens[token] !== null
          && String(
            tokens[token]
          ).trim()
        ) {
          ROOT.style.setProperty(
            PREFIX + cssName,
            String(
              tokens[token]
            )
          );
        }
      }
    );


    /*
     * CRM bridge:
     * Frappe CRM/Frappe UI uses semantic surfaces.
     * These variables make the selected MGOS colors
     * visible even inside the standalone Vue frontend.
     */

    const sidebar =
      tokens.structure
      || tokens.brand_soft
      || tokens.surface_alt
      || "#EAF6FD";

    const base =
      tokens.background
      || "#F6FAFD";

    const surface =
      tokens.surface
      || "#FFFFFF";

    ROOT.style.setProperty(
      "--surface-sidebar",
      sidebar
    );

    ROOT.style.setProperty(
      "--surface-base",
      base
    );

    ROOT.style.setProperty(
      "--surface-white",
      surface
    );

    ROOT.style.setProperty(
      "--surface-gray-1",
      tokens.surface_alt
      || surface
    );

    ROOT.style.setProperty(
      "--mg-crm-sidebar",
      sidebar
    );

    ROOT.style.setProperty(
      "--mg-crm-base",
      base
    );

    ROOT.style.setProperty(
      "--mg-crm-text",
      tokens.text
      || "#102033"
    );

    ROOT.style.setProperty(
      "--mg-crm-border",
      tokens.border
      || "#DDE4EA"
    );
  }


  function applyAttributes(theme) {

    ROOT.dataset.mgTheme =
      theme.theme_key || "";

    ROOT.dataset.mgMode =
      slug(
        theme.mode
        || "Light"
      );

    ROOT.dataset.mgDensity =
      slug(
        theme.density
        || "Comfortable"
      );

    ROOT.dataset.mgNavigation =
      slug(
        theme.navigation
        || "Sidebar"
      );

    const components =
      theme.components || {};

    const sidebar =
      components.sidebar || {};

    const navigation =
      components.navigation || {};

    ROOT.dataset.mgSidebarVariant =
      slug(
        sidebar.variant
        || navigation.variant
        || "default"
      );


    /*
     * CRM has its own light/dark preference.
     * An explicit MGOS Light/Dark theme should
     * render consistently rather than inherit
     * a stale CRM localStorage state.
     */

    const mode =
      String(
        theme.mode || ""
      ).toLowerCase();

    if (
      location.pathname.startsWith(
        "/crm"
      )
    ) {
      if (
        mode === "light"
        || mode === "dark"
      ) {
        try {
          localStorage.setItem(
            "theme",
            mode
          );
        } catch (_) {}

        ROOT.setAttribute(
          "data-theme",
          mode
        );
      }
    }
  }


  function crmAdapterCss(theme) {

    if (
      !location.pathname.startsWith(
        "/crm"
      )
    ) {
      return "";
    }

    return `
html[data-mg-theme] body,
html[data-mg-theme] #app {
  background: var(--mg-crm-base) !important;
  color: var(--mg-crm-text) !important;
}

html[data-mg-theme] .bg-surface-sidebar {
  background-color: var(--mg-crm-sidebar) !important;
}

html[data-mg-theme] .bg-surface-base {
  background-color: var(--mg-crm-base) !important;
}

html[data-mg-theme] .border-r,
html[data-mg-theme] .border-l,
html[data-mg-theme] .border-b,
html[data-mg-theme] .border-t {
  border-color: var(--mg-crm-border) !important;
}
`;
  }


  function applyTheme(theme) {

    if (
      !theme
      || !theme.theme_key
    ) {
      return;
    }

    applyTokens(theme);
    applyAttributes(theme);

    const css = "";

    styleNode().textContent =
      css
      + "\n"
      + crmAdapterCss(theme);

    window.dispatchEvent(
      new CustomEvent(
        "mgos-theme-applied",
        {
          detail: theme
        }
      )
    );
  }


  async function getCurrentTheme() {

    // Login has no authenticated theme context. Avoid a permission-error dialog.
    if (window.location.pathname === "/login" || window.frappe?.session?.user === "Guest") {
      return {};
    }

    /*
     * Desk: frappe.call is available.
     * CRM: standalone Vue frontend may not expose frappe.call,
     * therefore use the same authenticated REST method via fetch.
     */

    if (window.frappe?.call) {
      const response =
        await window.frappe.call(
          "mehanizacija_core.themes.api.current_theme"
        );

      return (
        response.message
        || {}
      );
    }

    const response =
      await fetch(
        "/api/method/mehanizacija_core.themes.api.current_theme",
        {
          credentials: "same-origin",
          headers: {
            Accept:
              "application/json"
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        "MGOS theme API unavailable"
      );
    }

    const data =
      await response.json();

    return (
      data.message
      || {}
    );
  }


  function mountContextBar() {
    if (location.pathname === "/login" || document.getElementById("mgos-global-shell")) {
      return;
    }
    const isCrm = location.pathname.startsWith("/crm");
    const crmApp = isCrm ? document.querySelector("#app") : null;
    // CRM standalone SPA requires its own bundle integration; app_include_js
    // does not load this shared bundle there. Keep this mount path idempotent
    // for a supported CRM integration without patching CRM's owned template.
    // CRM owns #app through Vue. Keep the shared shell outside that subtree so
    // route changes and component rerenders cannot erase it.
    const host = isCrm ? crmApp : (document.querySelector(".navbar, .page-head") || crmApp);
    if (!host) {
      return;
    }
    const storedLanguage = String(localStorage.getItem("mgos-language") || "").toLowerCase();
    const bootLanguage = String(storedLanguage || (window.frappe || {}).boot?.user?.language || (window.frappe || {}).boot?.lang || window.boot?.user?.language || document.documentElement.lang || "en").toLowerCase();
    const locale = ["uk", "sl", "hr"].find(code => bootLanguage === code || bootLanguage.startsWith(`${code}-`)) || "en";
    // All visible labels use Frappe's locale catalog; keep one translation source.
    const values = {
      ALL: tr("All countries"),
      SLOVENIA: tr("Slovenia · Mehanizacija Miler"),
      CROATIA: tr("Croatia · Ruralna Mehanizacija"),
    };
    const entities = {
      ALL: "",
      SLOVENIA: "MEHANIZACIJA MILER d.o.o.",
      CROATIA: "Ruralna Mehanizacija d.o.o.",
    };
    const saved = window.localStorage.getItem("mgos-context") || "ALL";
    const bar = document.createElement("div");
    bar.id = "mgos-global-shell";
    bar.className = "mgos-context-bar mgos-global-shell";
    const frappeApi = window.frappe || {};
    const language = locale;
    bar.innerHTML = `<span class="mgos-context-label">MGOS</span><label class="mgos-shell-field"><span>${tr("Data mode")}</span><select data-mode aria-label="${tr("Data mode")}"><option value="" selected disabled>${tr("Checking data mode…")}</option><option value="LIVE">LIVE</option><option value="DEMO">DEMO</option></select></label><label class="mgos-shell-field" data-role-field hidden><span>${tr("View as role")}</span><select data-role aria-label="${tr("View as role")}"></select></label><label class="mgos-shell-field"><span>${tr("Country and legal entity")}</span><select data-country aria-label="${tr("Country and legal entity")}"><option value="ALL">${values.ALL}</option><option value="SLOVENIA">${values.SLOVENIA}</option><option value="CROATIA">${values.CROATIA}</option></select></label><label class="mgos-shell-field"><span>${tr("Language")}</span><select data-language aria-label="${tr("Language")}"><option value="en">EN</option><option value="uk">UK</option><option value="sl">SL</option><option value="hr">HR</option></select></label><button type="button" class="btn btn-xs btn-default" data-return-live hidden>${tr("Return to Live")}</button><span data-demo-banner role="status"></span>`;
    const select = bar.querySelector("[data-country]");
    select.value = values[saved] ? saved : "ALL";
    bar.querySelector("[data-language]").value = language;
    const publishContext = notify => {
      window.mgosContext = {
        country: select.value,
        legal_entity: entities[select.value] || "",
        label: values[select.value],
      };
      if (notify) {
        window.dispatchEvent(new CustomEvent("mgos-context-changed", {detail: window.mgosContext}));
      }
    };
    publishContext(false);
    select.addEventListener("change", () => {
      window.localStorage.setItem("mgos-context", select.value);
      publishContext(true);
    });
    bar.querySelector("[data-language]").addEventListener("change", async event => {
      const targetLanguage = event.currentTarget.value;
      try {
        if (frappeApi.call) {
          await frappeApi.call("mehanizacija_core.api.preferences.set_language", {language: targetLanguage});
        } else {
          const csrf = frappeApi.csrf_token || window.csrf_token || window.boot?.csrf_token || document.querySelector('meta[name="csrf-token"]')?.content || document.cookie.match(/(?:^|; )csrf_token=([^;]*)/)?.[1] || "";
          const response = await fetch("/api/method/mehanizacija_core.api.preferences.set_language", {
            method: "POST", credentials: "same-origin",
            headers: {"Content-Type": "application/json", "X-Frappe-CSRF-Token": csrf},
            body: JSON.stringify({language: targetLanguage}),
          });
          if (!response.ok) throw new Error("Language preference update failed");
        }
        window.localStorage.setItem("mgos-language", targetLanguage);
        // Frappe resolves the request language from `_lang` before the
        // authenticated session language. The user preference is persisted
        // above; carrying `_lang` through this first navigation makes the
        // current Desk session switch immediately as well.
        const url = new URL(window.location.href);
        url.searchParams.set("_lang", targetLanguage);
        window.location.assign(url.toString());
      } catch (_) {
        event.currentTarget.value = language;
        if (frappeApi.show_alert) frappeApi.show_alert({message: tr("Language preference could not be saved."), indicator: "red"});
        else console.warn("MGOS language preference could not be saved", _);
      }
    });
    if (isCrm && crmApp && host === crmApp) {
      document.body.insertBefore(bar, crmApp);
    } else {
      host.parentNode.insertBefore(bar, host.nextSibling);
    }
  }

  async function demoCall(method, args = {}) {
    const readMethods = new Set(["context", "status", "workspace", "workspace_data", "table_data", "pipeline_data", "record_profile", "chart_data", "saved_views"]);
    const type = readMethods.has(method) ? "GET" : "POST";
    if (!window.mechanizacija?.call) throw new Error("Mode service unavailable");
    const response = await window.mechanizacija.call(`mehanizacija_core.demo.${method}`, args, type);
    return response?.message || {};
  }

  function validateModeContext(data, expectedMode = null) {
    const mode = data?.mode;
    const active = data?.active === true;
    if (!(["LIVE", "DEMO"].includes(mode)) || (mode === "DEMO") !== active || (expectedMode && mode !== expectedMode)) {
      throw new Error("Mode service returned an inconsistent context");
    }
    return {
      status: "ready", mode, role: data.role || (mode === "DEMO" ? "Administrator" : null),
      demoAvailable: data.demo_available !== false, active,
    };
  }

  function publishModeState(bar, data, notify = false, expectedMode = null) {
    const previous = window.mgosModeState || {};
    const next = validateModeContext(data, expectedMode);
    window.mgosModeState = next;
    // Compatibility aliases are projections only. Requests read mgosModeState.
    window.mgosDataMode = next.mode;
    window.mgosDemoRole = next.role;
    window.mgosModeUnavailable = false;
    const mode = bar.querySelector("[data-mode]");
    const roleField = bar.querySelector("[data-role-field]");
    const role = bar.querySelector("[data-role]");
    const banner = bar.querySelector("[data-demo-banner]");
    mode.value = next.mode;
    mode.querySelector('[value="DEMO"]').disabled = !next.demoAvailable;
    mode.disabled = !next.demoAvailable;
    bar.querySelector('[data-return-live]').hidden = next.mode !== "DEMO";
    roleField.hidden = next.mode !== "DEMO";
    role.innerHTML = (data.roles || []).map(item => `<option value="${item}">${tr(item)}</option>`).join("");
    if (next.role) role.value = next.role;
    banner.textContent = next.mode === "DEMO" ? tr("DEMO DATA — NOT PRODUCTION") : "";
    banner.className = next.mode === "DEMO" ? "text-warning" : "";
    bar._mgosModeContext = data;
    if (notify && (previous.mode !== next.mode || previous.role !== next.role)) {
      window.dispatchEvent(new CustomEvent("mgos-mode-changed", {detail: {mode: next.mode, role: next.role || ""}}));
    }
    return next;
  }

  function failClosedMode(bar) {
    const mode = bar.querySelector("[data-mode]");
    const roleField = bar.querySelector("[data-role-field]");
    const banner = bar.querySelector("[data-demo-banner]");
    window.mgosModeState = {status: "unavailable", mode: "UNKNOWN", role: null, demoAvailable: false};
    window.mgosDataMode = "UNKNOWN";
    window.mgosDemoRole = null;
    window.mgosModeUnavailable = true;
    mode.value = "";
    mode.disabled = true;
    mode.querySelector('[value="DEMO"]').disabled = true;
    roleField.hidden = true;
    bar.querySelector('[data-return-live]').hidden = true;
    banner.textContent = tr("Data mode could not be verified. Workspace data is hidden until retry.");
    banner.className = "text-danger";
    window.dispatchEvent(new CustomEvent("mgos-mode-unavailable"));
  }

  async function mountDemoSwitcher(refresh = false) {
    if (location.pathname === "/login") return null;
    const bar = document.getElementById("mgos-global-shell");
    if (!bar) return null;
    if (bar._mgosModePromise) return bar._mgosModePromise;
    if (bar.dataset.modeReady === "true" && !refresh) return bar._mgosModeContext;
    if (bar.dataset.modeLoading === "true") return null;
    bar.dataset.modeLoading = "true";
    const mode = bar.querySelector("[data-mode]");
    mode.value = window.mgosModeState.status === "ready" ? window.mgosModeState.mode : "";
    mode.disabled = true;
    bar._mgosModePromise = (async () => {
      try {
        const context = await demoCall("context");
        publishModeState(bar, context, true);
        if (bar.dataset.modeHandlers !== "true") {
          mode.addEventListener("change", () => {
            const requestedMode = mode.value;
            const previousMode = window.mgosModeState.mode;
            mode.value = previousMode;
            if (requestedMode === previousMode) return;
            switchMode(requestedMode === "DEMO" ? "enter" : "exit", requestedMode);
          });
          bar.querySelector("[data-role]").addEventListener("change", () => {
            const role = bar.querySelector("[data-role]");
            const requestedRole = role.value;
            role.value = window.mgosModeState.role || "Administrator";
            switchRole(requestedRole);
          });
          bar.querySelector("[data-return-live]").addEventListener("click", () => switchMode("exit", "LIVE"));
          bar.dataset.modeHandlers = "true";
        }
        bar.dataset.modeReady = "true";
        return window.mgosModeState;
      } catch (error) {
        console.error("MGOS mode context unavailable", error);
        failClosedMode(bar);
        delete bar.dataset.modeReady;
        return window.mgosModeState;
      } finally {
        delete bar.dataset.modeLoading;
        bar._mgosModePromise = null;
        if (window.mgosModeState.status === "ready") mode.disabled = !window.mgosModeState.demoAvailable;
      }
    })();
    return bar._mgosModePromise;

    async function switchMode(method, expectedMode) {
      if (bar._mgosModePromise || window.mgosModeState.status !== "ready") return;
      const previousMode = window.mgosModeState.mode;
      const modeControl = bar.querySelector("[data-mode]");
      modeControl.value = "";
      bar.querySelector("[data-demo-banner]").textContent = tr("Switching data mode…");
      bar.querySelector("[data-demo-banner]").className = "text-muted";
      modeControl.disabled = true;
      window.dispatchEvent(new CustomEvent("mgos-mode-changing"));
      bar.dataset.modeLoading = "true";
      bar._mgosModePromise = (async () => {
        try {
          const result = await demoCall(method);
          publishModeState(bar, result, true, expectedMode);
        } catch (error) {
          console.error("MGOS mode transition failed", error);
          try { publishModeState(bar, await demoCall("context"), true); }
          catch (contextError) { console.error("MGOS mode reconciliation failed", contextError); failClosedMode(bar); }
        } finally {
          delete bar.dataset.modeLoading;
          bar._mgosModePromise = null;
          modeControl.disabled = window.mgosModeState.status !== "ready" || !window.mgosModeState.demoAvailable;
        }
      })();
      return bar._mgosModePromise;
    }

    async function switchRole(requestedRole) {
      if (bar._mgosModePromise || window.mgosModeState.mode !== "DEMO") return;
      const roleControl = bar.querySelector("[data-role]");
      roleControl.disabled = true;
      window.dispatchEvent(new CustomEvent("mgos-mode-changing"));
      bar.dataset.modeLoading = "true";
      bar._mgosModePromise = (async () => {
        try {
          const result = await demoCall("set_role", {role: requestedRole});
          if (result.role !== requestedRole) throw new Error("Role context did not commit");
          publishModeState(bar, result, true, "DEMO");
        } catch (error) {
          console.error("MGOS Demo role transition failed", error);
          try { publishModeState(bar, await demoCall("context"), true); }
          catch (contextError) { console.error("MGOS mode reconciliation failed", contextError); failClosedMode(bar); }
        } finally {
          delete bar.dataset.modeLoading;
          bar._mgosModePromise = null;
          roleControl.disabled = window.mgosModeState.status !== "ready" || window.mgosModeState.mode !== "DEMO";
        }
      })();
      return bar._mgosModePromise;
    }
  }


  async function load() {
    // Resolve the per-user data mode before theme or workspace requests. Theme
    // settings are not needed for synthetic Demo rendering, and must not make a
    // legacy live API request while the Demo guard is active.
    const mountShellAndMode = async (refresh = false) => {
      mountContextBar();
      if (document.getElementById("mgos-global-shell")) {
        await mountDemoSwitcher(refresh);
        return true;
      }
      return false;
    };
    if (!(await mountShellAndMode()) && document.body) {
      // Frappe can attach the Desk navbar after DOMContentLoaded. Keep the
      // global controls mounted once the shell becomes available instead of
      // silently leaving users without mode, role, country, or language scope.
      const observer = new MutationObserver(async () => {
        if (!document.getElementById("mgos-global-shell") && await mountShellAndMode()) {
          if (!location.pathname.startsWith("/crm")) observer.disconnect();
        }
      });
      observer.observe(document.body, {childList: true, subtree: true});
      if (!location.pathname.startsWith("/crm")) window.setTimeout(() => observer.disconnect(), 15000);
    }
    const frappeApi = window.frappe || {};
    if (frappeApi.route && typeof frappeApi.route.on === "function") {
      frappeApi.route.on("change", () => {
        mountShellAndMode().catch(() => {});
      });
    }
    if (location.pathname.startsWith("/crm")) {
      window.addEventListener("popstate", () => mountShellAndMode().catch(() => {}));
      window.addEventListener("hashchange", () => mountShellAndMode().catch(() => {}));
    }
    try {
      if (!window.mgosModeUnavailable && window.mgosDataMode !== "DEMO") {
        const theme = await getCurrentTheme();
        applyTheme(theme);
      }
    } catch (error) {
      console.warn(
        "MGOS theme runtime:",
        error
      );
    }
  }


  window.mechanizacija = window.mechanizacija || {};
  window.mechanizacija.mountShell = () => {
    mountContextBar();
    return mountDemoSwitcher();
  };
  window.mechanizacija.ensureModeReady = async () => {
    mountContextBar();
    const bar = document.getElementById("mgos-global-shell");
    if (!bar) {
      window.mgosModeState = {status: "unavailable", mode: "UNKNOWN", role: null, demoAvailable: false};
      window.mgosDataMode = "UNKNOWN";
      window.mgosDemoRole = null;
      window.mgosModeUnavailable = true;
      return window.mgosModeState;
    }
    if (bar.dataset.modeReady === "true" && window.mgosModeState.status === "ready") return window.mgosModeState;
    await mountDemoSwitcher(true);
    return window.mgosModeState;
  };
  window.mechanizacija.applyTheme = applyTheme;
  window.mechanizacija.reloadCurrentTheme = async function() {
      const theme =
        await getCurrentTheme();

      applyTheme(theme);

    return theme;
  };
  window.mechanizacija.call = async (method, args = {}, type = "GET") => {
    if (type !== "GET") {
      if (!window.frappe?.call) throw new Error("This action is unavailable in the CRM application shell.");
      return window.frappe.call({method, args, type});
    }
    const params = new URLSearchParams();
    Object.entries(args || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) params.set(key, typeof value === "object" ? JSON.stringify(value) : String(value));
    });
    const response = await fetch(`/api/method/${method}?${params}`, {
      method: "GET", credentials: "same-origin", headers: {Accept: "application/json"},
    });
    const result = await response.json();
    if (!response.ok || result.exc) throw new Error("Workspace request unavailable");
    return result;
  };


  if (
    document.readyState
    === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      load,
      {
        once: true
      }
    );
  } else {
    load();
  }
})();
